import React, {useState, useEffect} from 'react';
import CustomTable from '../../components/customTable/CustomTable';
import {t, getLanguage} from 'react-switch-lang';
import './KeyRiskIndicators.scss';
import SelectList from '../../components/FormFields/Select';
import {
  getAllSubProcesses,
  deleteKeyRisk,
  copyAllKeyIndicators
} from '../../services/keyRiskIndicatorsService';
import {ReactComponent as OptionsImg} from './img/options.svg';
import {ReactComponent as PlusImg} from './img/plus.svg';
import {useHistory} from 'react-router-dom';
import {useUserContext} from '../../contexts/UserContext';
import Prompt from '../../components/prompt/prompt';
import Toast from '../../components/toast/Toast';
import OccurrenceModal from './viewKeyRiskIndicator/riskOccurrenceModal/OccurrenceModal';
import Swal from 'sweetalert2';
import {useDepartmentContext} from '../../contexts/DepartmentContext';
import Dropdown from '../../components/droppdown/dropdown';
import roles from '../../utils/roles';
import SelectInfinite from '../../components/FormFields/SelectInfinite';
import {useForm, FormProvider} from 'react-hook-form';
import {appModules} from '../../utils/const';
import InputText from '../../components/FormFields/InputText';
import {escalationCalculationTypeOptions, periods} from './utils/periods';

const KeyRiskIndicators = () => {
  const [subProcesses, setSubProcesses] = useState([]);
  const [disableSubprocess, setDisableSubProcess] = useState(true);
  const [subprocessPage, setSubprocessPage] = useState(0);
  const [hasMoreSubprocesses, setHasMoreSubprocesses] = useState(true);
  const [loadingSubprocesses, setLoadingSubprocesses] = useState(false);
  const methods = useForm({});
  const {setValue, watch} = methods;
  const watchProcess = watch('process');
  const watchSubprocess = watch('subprocess');
  const watchDepartments = watch('department');
  const watchIsKeyIndicator = watch('isKeyIndicator');
  const watchIndicatorName = watch('indicatorName');
  const userAuthorities = useUserContext().authorities;
  const userDepartments = useDepartmentContext();
  const history = useHistory();
  const lang = getLanguage();
  let userDepartmentsIds = [];
  const yesNoOptions = [
    {value: true, label: t('common.yes')},
    {value: false, label: t('common.no')}]
  const userSuperAdmin = userAuthorities.some((r) =>
    r.includes(roles.role_super_admin)
  );
  const userRiskSector = userAuthorities.some((r) =>
    r.includes(roles.role_risk_sector)
  );
  const userResponsible = userAuthorities.some((r) =>
    r.includes(roles.role_responsible_user)
  );
  const userInCharge = userAuthorities.some((r) =>
    r.includes(roles.role_user_in_charge)
  );

  userDepartments.forEach((department) => {
    userDepartmentsIds.push(department?.id);
  });

  const userDepartmentsOptions = userDepartments?.map(r => ({
    value: r?.id,
    label: lang === 'mne' ? r?.name : r?.nameEn,
  }));

  const actionsRedirect = {
    editUrl: '/key-risk-indicators/edit',
    editTooltip: 'Pages.KeyRiskIndicators.editKeyRiskIndicator',
    damageTooltip: 'Pages.KeyRiskIndicators.damageKeyRiskIndicator',
    deleteTooltip: 'Pages.KeyRiskIndicators.deleteKeyRiskIndicator',
  };
  const actionsWidth = 100;

  /*** For constructing filters query ***/
  const query = new Map([]).set('activate.equals', true);
  const [complexQuery, setComplexQuery] = useState(
    userSuperAdmin || userRiskSector
      ? query
      : query.set('departmentId.in', userDepartmentsIds)
  );

  const columns = [
    {
      dataIndex: 'id',
      title: t('Pages.KeyRiskIndicators.id'),
      editable: true,
      placeholder: t(''),
      width: 50,
    },
    {
      dataIndex: 'indicatorName',
      title: t('Pages.KeyRiskIndicators.indicatorName'),
      editable: true,
      placeholder: t(''),
      width: 200,
    },
    {
      dataIndex: 'isKeyIndicator',
      title: t('Pages.KeyRiskIndicators.isKeyIndicatorColumn'),
      editable: true,
      placeholder: t(''),
      width: 80,
      render: (value) => value === true ? t('common.yes') : t('common.no')
    },
    {
      dataIndex: lang === 'eng' ? 'minValue' : 'minValue',
      title: t('Pages.KeyRiskIndicators.escalationPoint'),
      editable: true,
      placeholder: t(''),
      width: 120,
    },
    {
      dataIndex: 'occurrenceCount',
      title: t('Pages.KeyRiskIndicators.occurrenceCount'),
      editable: true,
      placeholder: t(''),
      width: 130
    },
    {
      dataIndex: 'indicatorPeriod',
      title: t('Pages.KeyRiskIndicators.indicatorPeriod'),
      editable: true,
      placeholder: t(''),
      width: 130,
      render: (request) => {
        let label = '';
        for (let period of periods) {
          if (period?.value === request) {
            label = period?.label;
          }
        }
        return `${label}`
      }
    },
    {
      dataIndex: lang === 'eng' ? 'departmentNameEn' : 'departmentName',
      title: t('Pages.KeyRiskIndicators.department'),
      editable: true,
      placeholder: t(''),
      width: 200,
    },
    {
      dataIndex: lang === 'eng' ? 'riskDescriptionEn' : 'riskDescription',
      title: t('Pages.KeyRiskIndicators.risk'),
      editable: true,
      placeholder: t(''),
      width: 100,
    },
    {
      dataIndex: lang === 'eng' ? 'processNameEn' : 'processName',
      title: t('Pages.KeyRiskIndicators.process'),
      editable: true,
      placeholder: t(''),
      width: 150
    },
    // {
    //   dataIndex: lang === 'eng' ? 'subprocessNameEn' : 'subprocessName',
    //   title: t('Pages.KeyRiskIndicators.subProcess'),
    //   editable: true,
    //   placeholder: t(''),
    // },
    // {
    //   dataIndex: 'escalationCalculationType',
    //   title: t('Pages.KeyRiskIndicators.escalationCalculationType'),
    //   editable: true,
    //   placeholder: t(''),
    //   render: (request) => {
    //     let label = '';
    //     for (let period of escalationCalculationTypeOptions) {
    //       if (period?.value === request) {
    //         label = period?.label;
    //       }
    //     }
    //     return `${label}`
    //   }
    // },
    // {
    //   dataIndex: 'escalationReached',
    //   title: t('Pages.KeyRiskIndicators.escalationReached'),
    //   editable: true,
    //   placeholder: t(''),
    //   width: 170,
    //   render: (value) => value === true ? t('common.yes') : t('common.no')
    // }
  ];

  // const fetchSubprocesses = async (pageToLoad = 0, replace = false) => {
  //   if (!watchProcess?.value) return;
  //   try {
  //     setLoadingSubprocesses(true);
  //     const {data} = await getAllSubProcesses(
  //       watchProcess?.value,
  //       20,
  //       pageToLoad
  //     );
  //
  //     const mapped = data?.map((item) =>
  //       lang === 'eng'
  //         ? {value: item?.id, label: item?.nameEn}
  //         : {value: item?.id, label: item?.name}
  //     );
  //
  //     setSubProcesses(prev =>
  //       replace ? mapped : [...prev, ...mapped]
  //     );
  //
  //     setSubprocessPage(pageToLoad);
  //     setHasMoreSubprocesses(data.length === 20);
  //   }
  //   catch (e){
  //   }finally {
  //     setLoadingSubprocesses(false);
  //   }
  // };

  // useEffect(() => {
  //   if (watchProcess?.value) {
  //     setComplexQuery(prev => new Map(prev).set('processId.equals', watchProcess.value));
  //     setDisableSubProcess(false);
  //     setSubProcesses([]);
  //     setSubprocessPage(0);
  //     setHasMoreSubprocesses(true);
  //     setValue('subprocess', '', {
  //       shouldValidate: false,
  //       shouldDirty: false,
  //     });
  //     setComplexQuery(prev => {
  //       const query = new Map(prev);
  //       query.delete('subprocessId.equals');
  //       return query;
  //     });
  //     fetchSubprocesses(0, true);
  //   } else {
  //     setComplexQuery(prev => {
  //       const query = new Map(prev);
  //       query.delete('processId.equals');
  //       query.delete('subprocessId.equals');
  //       return query;
  //     });
  //     setDisableSubProcess(true);
  //     setSubProcesses([]);
  //     setSubprocessPage(0);
  //     setHasMoreSubprocesses(true);
  //     setValue('subprocess', '', {
  //       shouldValidate: false,
  //       shouldDirty: false,
  //     });
  //   }
  // }, [watchProcess]);

  // useEffect(() => {
  //   if (watchSubprocess?.value) {
  //     setComplexQuery(prev => new Map(prev).set('subprocessId.equals', watchSubprocess.value));
  //   } else {
  //     setComplexQuery(prev => {
  //       const query = new Map(prev);
  //       query.delete('subprocessId.equals');
  //       return query;
  //     });
  //   }
  // }, [watchSubprocess]);

  useEffect(() => {
    const ids = Array.isArray(watchDepartments)
      ? watchDepartments?.map(r => r?.value).filter(Boolean)
      : [];

    if (ids?.length) {
      setComplexQuery(prev => new Map(prev).set('departmentId.in', ids));
    } else {
      setComplexQuery(prev => {
        const query = new Map(prev);
        query.delete('departmentId.in');
        return query;
      });
    }
  }, [watchDepartments]);

  useEffect(() => {
    if (typeof watchIsKeyIndicator?.value === 'boolean') {
      setComplexQuery(prev =>
        new Map(prev).set('isKeyIndicator.equals', watchIsKeyIndicator?.value)
      );
    } else {
      setComplexQuery(prev => {
        const query = new Map(prev);
        query.delete('isKeyIndicator.equals');
        return query;
      });
    }
  }, [watchIsKeyIndicator]);

  useEffect(() => {
    const fieldName =
      lang === 'eng' ? 'indicatorNameEn.contains' : 'indicatorName.contains';

    if (watchIndicatorName?.trim()) {
      setComplexQuery(prev => {
        const query = new Map(prev);
        query.set(fieldName, watchIndicatorName.trim());
        return query;
      });
    } else {
      setComplexQuery(prev => {
        const query = new Map(prev);
        query.delete('indicatorName.contains');
        query.delete('indicatorNameEn.contains');
        return query;
      });
    }
  }, [watchIndicatorName, lang]);

  const toAddKey = () => {
    history.push('/key-risk-indicators/add');
  };

  const toSingleKey = (id) => {
    const elementByID = document.getElementById('app-body');
    if (elementByID) elementByID.scrollTop = 0;
    window.scrollTo(0, 0);
    history.push(`/key-risk-indicators/${id}`);
  };

  const toEditKeyRisk = (id) => {
    history.push({
      pathname: `/key-risk-indicators/${id}`,
      state: {isEditing: true},
    });
  };

  const onDelete = async (record) => {
    return new Promise((resolve, reject) => {
      Prompt.fire({
        title: t('title.deleteKeyRisk'),
        text: t('question.delete', {
          entity: t('Pages.common.keyRiskIndicator2'),
        }),
        confirmButtonText: t('common.confirm'),
        cancelButtonText: t('common.cancel'),
        preConfirm: async () => {
          try {
            const response = await deleteKeyRisk(record.id);
            if (response.status === 204) {
              Toast.fire({
                title: t('Pages.messages.deleteSuccess', {
                  entity: t('Pages.common.keyRiskIndicator'),
                }),
                icon: 'success',
              });
              resolve(response);
            } else {
              reject(response);
            }
          } catch (err) {
           if (err?.response?.data?.code === 'key_indicator_deletion_blocked_by_open_risks') {
              Toast.fire({
                title:t('message.keyIndicatorDeletionBlockedBOpenRisks'),
                icon: 'error',
              })
            } else {
             Swal.fire({
               text: t('Pages.messages.deleteError', {
                 entity:
                   lang === 'eng'
                     ? t('Pages.common.keyRiskIndicator2')
                     : t('Pages.common.keyRiskIndicator3'),
               }),
               icon: 'error',
             })
           }
          }
        },
      });
    });
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [updateTable, setUpdateTable] = useState(false);
  const [tableRowId, setTableRowId] = useState();

  const tableKey = `${updateTable}-${JSON.stringify(
    Array.from(complexQuery.entries())
  )}`;

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const openAddModal = (id) => {
    setIsModalOpen(true);
    setTableRowId(id);
  };

  const copy = async () => {
    try {
      const response = await copyAllKeyIndicators();
      if (response.status === 204) {
        Toast.fire({
          title: t('Pages.messages.copySuccess', {
            entity: t('Pages.common.keyRiskIndicators'),
          }),
          icon: 'success',
        });
      }
    } catch (err) {
      Swal.fire({
        text: t('Pages.messages.copyError', {
          entity: t('Pages.common.keyRiskIndicators2'),
        }),
        icon: 'error',
      });
    }
  };

  // const handleSubprocessLoadMore = () => {
  //   if (hasMoreSubprocesses && !loadingSubprocesses) {
  //     fetchSubprocesses(subprocessPage + 1, false);
  //   }
  // };
  return (
    <div>
      {userSuperAdmin || userRiskSector ? (
        <div className="controls d-flex align-items-center justify-content-end">
          <div className="administration-template">
            <div className="container-fluid pr-0 pl-0 ">
              <div className="row ml-0 mr-0 justify-content-end">
                <div className="col-3 col-padding d-flex justify-content-end">
                  <button
                    type="button"
                    className="primary-btn mr-2"
                    onClick={toAddKey}
                  >
                    <PlusImg />
                    <div className="ml-2">
                      {t('Pages.KeyRiskIndicators.add')}
                    </div>
                  </button>
                </div>
                <div className="d-flex align-items-center">
                  <Dropdown
                    buttonClass="options-btn"
                    trigger={<OptionsImg />}
                    children={
                      <>
                        <li
                          onClick={() => {
                            copy();
                          }}
                        >
                          {t('common.copy')}
                        </li>
                      </>
                    }
                  ></Dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      <div className="administration-template">
        <FormProvider {...methods}>
          <form>
        <div className="container-fluid pr-0 pl-0 mb-4">
          <div className="row ml-0 mr-0">
            {/*<div className="col-4 col-padding">*/}
            {/*  <SelectInfinite*/}
            {/*    api="processes?active.equals=true"*/}
            {/*    name="process"*/}
            {/*    placeholder={t('Pages.KeyRiskIndicators.placeholder.process')}*/}
            {/*    labelKey={lang === 'mne' ? 'name' : 'nameEn'}*/}
            {/*    className="select"*/}
            {/*  />*/}
            {/*</div>*/}
            {/*<div className="col-4 col-padding">*/}
            {/*  <SelectList*/}
            {/*    name="subprocess"*/}
            {/*    isDisabled={disableSubprocess}*/}
            {/*    placeholder={t('Pages.KeyRiskIndicators.placeholder.subprocess')}*/}
            {/*    isClearable*/}
            {/*    options={subProcesses}*/}
            {/*    onLoadMore={handleSubprocessLoadMore}*/}
            {/*    hasMore={hasMoreSubprocesses}*/}
            {/*    isLoading={loadingSubprocesses}*/}
            {/*  />*/}
            {/*</div>*/}
            <div className="col-4 col-padding">
              <InputText
                type="text"
                // className={"padding"}
                name="indicatorName"
                placeholder={t('Pages.KeyRiskIndicators.searchIndicatorName')}
              />
            </div>
            <div className="col-4 col-padding">
              <SelectInfinite
                options={yesNoOptions}
                name="isKeyIndicator"
                // className={"padding"}
                placeholder={t('Pages.KeyRiskIndicators.isKeyIndicator')}
                labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                isClearable
                isMulti={false}
              /></div>
            <div className="col-4 col-padding">
              {userSuperAdmin || userRiskSector ?
                <SelectInfinite
                api={`departments?appModuleId.equals=${appModules?.riskModule}&active.equals=true`}
                name="department"
                placeholder={t('Pages.KeyRiskIndicators.department')}
                labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                className="select"
                isClearable
                isMulti={true}
              /> :
                <SelectInfinite
                  options={userDepartmentsOptions}
                  name="department"
                  placeholder={t('Pages.KeyRiskIndicators.department')}
                  labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                  className="select"
                  isClearable
                  isMulti={true}
                />}
            </div>
          </div>
          <OccurrenceModal
            key={isModalOpen}
            keyId={tableRowId}
            title={t('Pages.ViewKeyRiskIndicator.add')}
            isOpen={isModalOpen}
            isClosed={closeModal}
            updateTable={() => {
              setUpdateTable(true);
            }}
            escPressed={() => {
              closeModal();
            }}
          />
        </div>
          </form>
        </FormProvider>
        <CustomTable
          key={tableKey}
          api={'/key-indicators'}
          query={complexQuery}
          columns={columns}
          methods={{onDelete}}
          sort={lang === 'eng' ? 'indicatorNameEn' : 'indicatorName'}
          actionsRedirect={actionsRedirect}
          actionsWidth={actionsWidth}
          onClickRow={toSingleKey}
          onColumnAdd={openAddModal}
          onColumnEdit={toEditKeyRisk}
          updateTable={updateTable}
          className={'table-hover'}
          roles={{
            userSuperAdmin: userSuperAdmin,
            userRiskSector: userRiskSector,
            userInCharge: userInCharge,
            userResponsible: userResponsible,
            departments: userDepartmentsIds,
          }}
        />
      </div>
    </div>
  );
};

export default KeyRiskIndicators;
